/**
 * @generated SignedSource<<16e63db457495b31e04b7e2e3ac12962>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type DevOpsProviderNamespace = "ASAP" | "CLASSIC" | "FORGE" | "OAUTH" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type main_softwareCodePage_Header$data = {
  readonly devOps: {
    readonly providers: {
      readonly devInfoProviders: ReadonlyArray<{
        readonly __typename: "DevOpsDevInfoProvider";
        readonly name: string | null | undefined;
        readonly namespace: DevOpsProviderNamespace | null | undefined;
      } | null | undefined> | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"main_softwareCodePage_MoreMenu">;
    };
  };
  readonly " $fragmentType": "main_softwareCodePage_Header";
};
export type main_softwareCodePage_Header$key = {
  readonly " $data"?: main_softwareCodePage_Header$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_softwareCodePage_Header">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "siteAri"
    }
  ],
  "kind": "Fragment",
  "name": "main_softwareCodePage_Header",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "DevOps",
        "kind": "LinkedField",
        "name": "devOps",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "args": [
                {
                  "kind": "Variable",
                  "name": "id",
                  "variableName": "siteAri"
                },
                {
                  "kind": "Literal",
                  "name": "providerTypes",
                  "value": [
                    "DEV_INFO"
                  ]
                }
              ],
              "concreteType": "DevOpsProviders",
              "kind": "LinkedField",
              "name": "providers",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "main_softwareCodePage_MoreMenu"
                },
                {
                  "concreteType": "DevOpsDevInfoProvider",
                  "kind": "LinkedField",
                  "name": "devInfoProviders",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "__typename"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "name"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "namespace"
                    }
                  ]
                }
              ]
            },
            "action": "THROW",
            "path": "devOps.providers"
          }
        ]
      },
      "action": "THROW",
      "path": "devOps"
    }
  ],
  "type": "Query"
};

(node as any).hash = "ab147a339286ba5968da384a6edd4ca1";

export default node;
